import { Card } from "antd";
import React from "react";

const TotalProduct = (props) => {
    return (
      <Card title={<h1>{props.title}</h1>}>
        <div className='box'>
          <img src={props.image} width={60} height={60} alt='gambar' />
          <p>{props.length} Shirt</p>
        </div>
      </Card>
    );
}

export default TotalProduct;

